module.exports = "../../../../platform/assets/pageMainIcon/youth_yewushezhilei6.svg";